import { render, staticRenderFns } from "./revision-anual.vue?vue&type=template&id=2af7fc01&scoped=true&"
import script from "./revision-anual.vue?vue&type=script&lang=js&"
export * from "./revision-anual.vue?vue&type=script&lang=js&"
import style0 from "./revision-anual.vue?vue&type=style&index=0&id=2af7fc01&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af7fc01",
  null
  
)

export default component.exports